import queryString from 'query-string'

export const DEVICE_REGISTER = (data) => {
    return "/device/register?" + queryString.stringify(data, {encode: true})
}
export const DEVICE_ADAPT = (id) => {
    return "/adapt/custom/discharge/" + id
}
export const DEVICE_ADAPT_RESOURCE = () => {
    return "https://yaleembedapi.amstonstudio.com/adapt/resources"
}
export const DEVICE_ADAPT_START = () => {
    return "/adapt/custom/discharge/start"
}
export const DEVICE_ADAPT_UPDATE = (id) => {
    return "/adapt/custom/discharge/" + id
}
export const DEVICE_ADAPT_STEP = (id) => {
    return "/device/" + id + "/survey/step"
}
export const DEVICE_ADAPT_PREVIOUS_STEP = (id, surveyId) => {
    return "/device/" + id + "/survey/" + surveyId + "/step/back"
}
